export default "__VITE_ASSET__B7Kr8JgN__"